/** Resolve the effective team-scoring flag for a round.
 *  round.team_scoring_override > trip.team_scoring > true */
export function effectiveTeamScoring(trip, round) {
  if (round?.team_scoring_override != null) return round.team_scoring_override;
  return trip?.team_scoring ?? true;
}

/** Resolve the scoring format for a round. Default: stableford. */
export function roundFormat(round) {
  return round?.format || 'stableford';
}

/** Does a round have any non-zero hole_strokes entries (individual or team)?
 *  Also checks the `has_scores` summary field from the stripped trip response. */
export function roundHasScores(round) {
  if (round?.has_scores) return true;
  const hs = round?.hole_strokes;
  if (hs && Object.values(hs).some(arr =>
    Array.isArray(arr) && arr.some(v => v > 0)
  )) return true;
  const ths = round?.team_hole_strokes;
  if (ths && Object.values(ths).some(arr =>
    Array.isArray(arr) && arr.some(v => v > 0)
  )) return true;
  return false;
}

/** Short column/label text for leaderboard-shaped displays, per format. */
export function formatValueLabel(fmt) {
  return fmt === 'nsp' ? 'Net' : 'Pts';
}

/** Running summary value for a player mid-round, per format.
 *  Stableford → running Stableford total (round.scores[playerId])
 *  NSP → running gross strokes total (sum of hole_strokes non-zero) */
export function playerRoundRunningValue(round, playerId) {
  const fmt = (round && round.format) || 'stableford';
  if (fmt === 'nsp') {
    const strokes = (round.hole_strokes && round.hole_strokes[playerId]) || [];
    return strokes.reduce((acc, s) => acc + (Number(s) > 0 ? Number(s) : 0), 0);
  }
  return (round && round.scores && round.scores[playerId]) || 0;
}

/** Per-hole summary value for a player.
 *  Stableford → Stableford points (null = not yet scored)
 *  NSP → gross strokes (0 = not yet scored) */
export function playerHoleValue(round, playerId, holeIdx) {
  const fmt = (round && round.format) || 'stableford';
  if (fmt === 'nsp') {
    const arr = round.hole_strokes && round.hole_strokes[playerId];
    return arr && Number(arr[holeIdx]) > 0 ? Number(arr[holeIdx]) : 0;
  }
  const arr = round.hole_scores && round.hole_scores[playerId];
  const v = arr && arr[holeIdx];
  return (typeof v === 'number' && v >= 0) ? v : null;
}
